/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PurchaseCancelInfoOrderInfoVo } from './PurchaseCancelInfoOrderInfoVo';
import {
    PurchaseCancelInfoOrderInfoVoFromJSON,
    PurchaseCancelInfoOrderInfoVoFromJSONTyped,
    PurchaseCancelInfoOrderInfoVoToJSON,
    PurchaseCancelInfoOrderInfoVoToJSONTyped,
} from './PurchaseCancelInfoOrderInfoVo';
import type { PurchaseCancelInfoGoodsInfoVo } from './PurchaseCancelInfoGoodsInfoVo';
import {
    PurchaseCancelInfoGoodsInfoVoFromJSON,
    PurchaseCancelInfoGoodsInfoVoFromJSONTyped,
    PurchaseCancelInfoGoodsInfoVoToJSON,
    PurchaseCancelInfoGoodsInfoVoToJSONTyped,
} from './PurchaseCancelInfoGoodsInfoVo';

/**
 * 
 * @export
 * @interface PurchaseCancelInfoVo
 */
export interface PurchaseCancelInfoVo {
    /**
     * 取消记录ID
     * @type {number}
     * @memberof PurchaseCancelInfoVo
     */
    id?: number;
    /**
     * 要代买取消的商品id数组
     * @type {Array<number>}
     * @memberof PurchaseCancelInfoVo
     */
    cancelRecordGoodsIds?: Array<number>;
    /**
     * 取消原因 1 拍错规格 / 型号 2 重复下单 3 选错收货信息 4 商品信息不符 5 库存 / 发货问题 6 临时不需要 7 预算调整 8 其他原因
     * @type {number}
     * @memberof PurchaseCancelInfoVo
     */
    cancelReason?: number;
    /**
     * 取消原因详情
     * @type {string}
     * @memberof PurchaseCancelInfoVo
     */
    cancelReasonDetail?: string;
    /**
     * 是否发送短信通知 0 不发送  1 发送
     * @type {number}
     * @memberof PurchaseCancelInfoVo
     */
    sendSms?: number;
    /**
     * 
     * @type {PurchaseCancelInfoOrderInfoVo}
     * @memberof PurchaseCancelInfoVo
     */
    orderInfo?: PurchaseCancelInfoOrderInfoVo;
    /**
     * 商品信息
     * @type {Array<PurchaseCancelInfoGoodsInfoVo>}
     * @memberof PurchaseCancelInfoVo
     */
    goodsInfo?: Array<PurchaseCancelInfoGoodsInfoVo>;
}

/**
 * Check if a given object implements the PurchaseCancelInfoVo interface.
 */
export function instanceOfPurchaseCancelInfoVo(value: object): value is PurchaseCancelInfoVo {
    return true;
}

export function PurchaseCancelInfoVoFromJSON(json: any): PurchaseCancelInfoVo {
    return PurchaseCancelInfoVoFromJSONTyped(json, false);
}

export function PurchaseCancelInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseCancelInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'cancelRecordGoodsIds': json['cancelRecordGoodsIds'] == null ? undefined : json['cancelRecordGoodsIds'],
        'cancelReason': json['cancelReason'] == null ? undefined : json['cancelReason'],
        'cancelReasonDetail': json['cancelReasonDetail'] == null ? undefined : json['cancelReasonDetail'],
        'sendSms': json['sendSms'] == null ? undefined : json['sendSms'],
        'orderInfo': json['orderInfo'] == null ? undefined : PurchaseCancelInfoOrderInfoVoFromJSON(json['orderInfo']),
        'goodsInfo': json['goodsInfo'] == null ? undefined : ((json['goodsInfo'] as Array<any>).map(PurchaseCancelInfoGoodsInfoVoFromJSON)),
    };
}

export function PurchaseCancelInfoVoToJSON(json: any): PurchaseCancelInfoVo {
    return PurchaseCancelInfoVoToJSONTyped(json, false);
}

export function PurchaseCancelInfoVoToJSONTyped(value?: PurchaseCancelInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'cancelRecordGoodsIds': value['cancelRecordGoodsIds'],
        'cancelReason': value['cancelReason'],
        'cancelReasonDetail': value['cancelReasonDetail'],
        'sendSms': value['sendSms'],
        'orderInfo': PurchaseCancelInfoOrderInfoVoToJSON(value['orderInfo']),
        'goodsInfo': value['goodsInfo'] == null ? undefined : ((value['goodsInfo'] as Array<any>).map(PurchaseCancelInfoGoodsInfoVoToJSON)),
    };
}

